(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["free-shipping-bar"] && !Shopify.designMode) return;
  try {
    const updateKivaroCartTaxNote = () => {
  if (!document.documentElement.lang.toLowerCase().startsWith('de')) return;
  document.querySelectorAll('#CartDrawer .tax-note, #main-cart .tax-note').forEach((note) => {
    note.textContent = 'inkl. MwSt. · Kostenloser Versand ab CHF 59.–';
  });
};

const scheduleKivaroCartTaxNoteUpdate = () => {
  window.requestAnimationFrame(updateKivaroCartTaxNote);
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', updateKivaroCartTaxNote, { once: true });
} else {
  updateKivaroCartTaxNote();
}
document.addEventListener('afterCartChanged', scheduleKivaroCartTaxNoteUpdate);
document.addEventListener('afterUpdateQuantity', scheduleKivaroCartTaxNoteUpdate);
document.addEventListener('shopify:section:load', scheduleKivaroCartTaxNoteUpdate);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kivaro-offers"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('kivaro-starter')){
  customElements.define('kivaro-starter',class extends HTMLElement{
    connectedCallback(){
      if(this.ready)return;
      this.ready=true;
      const button=this.querySelector('button');
      const status=this.querySelector('[role="status"]');
      button.hidden=false;
      button.addEventListener('click',async()=>{
        button.disabled=true;
        this.setAttribute('aria-busy','true');
        status.textContent='';
        try{
          const response=await fetch(this.dataset.addUrl,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:this.dataset.sand,quantity:1},{id:this.dataset.glass,quantity:1}]})});
          if(!response.ok)throw new Error('cart');
          await response.json();
          location.assign(this.dataset.cartUrl);
        }catch(error){
          status.textContent=this.dataset.error;
          button.disabled=false;
          this.removeAttribute('aria-busy');
        }
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kivaro-product-facts"] && !Shopify.designMode) return;
  try {
    const updateKivaroShippingCopy = () => {
  if (!document.documentElement.lang.toLowerCase().startsWith('de')) return;
  const oldCopy = 'Versand Schweiz: CHF 8.50 unter CHF 59; ab CHF 59 kostenlos.';
  const newCopy = '· Kostenloser Versand ab CHF 59.–';

  document.querySelectorAll('.product__tax').forEach((element) => {
    const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      if (node.nodeValue.includes(oldCopy)) {
        node.nodeValue = node.nodeValue.replace(oldCopy, newCopy);
      }
    }
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', updateKivaroShippingCopy, { once: true });
} else {
  updateKivaroShippingCopy();
}
document.addEventListener('shopify:section:load', updateKivaroShippingCopy);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kivaro-scent-filter"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('kivaro-scent-filter'))customElements.define('kivaro-scent-filter',class extends HTMLElement{
 connectedCallback(){
  const start=()=>{if(!this.isConnected||this.ready)return;const container=this.closest('#ProductGridContainer');const cards=Array.from(container.querySelectorAll('[data-kv-families]'));if(!cards.length)return;this.ready=true;let selected='all';const available=this.querySelector('[data-available]');const buttons=Array.from(this.querySelectorAll('[data-family]'));
   const update=()=>{let count=0;cards.forEach(card=>{const match=(selected==='all'||card.dataset.kvFamilies.trim().split(/\s+/).includes(selected))&&(!available.checked||card.dataset.kvAvailable==='true');card.hidden=!match;if(match)count++;});this.querySelector('[data-count]').textContent=count;this.querySelector('[data-empty]').hidden=count!==0;buttons.forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.family===selected)));};
   buttons.forEach(button=>{if(button.dataset.family!=='all'&&!cards.some(card=>card.dataset.kvFamilies.trim().split(/\s+/).includes(button.dataset.family)))button.hidden=true;button.addEventListener('click',()=>{selected=button.dataset.family;update();});});available.addEventListener('change',update);this.hidden=false;update();};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
 }
});
  } catch(e) { console.error(e); }
})();

})();
